export default "__VITE_ASSET__BOXdoWhi__"